import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { FaFacebookF, FaInstagram, FaLinkedin, FaTiktok } from 'react-icons/fa';
import { MenuOutlined } from '@ant-design/icons';
import logo from '../assets/logo.png';
import infoImage from '../assets/compInfo.jpg';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();

  const [isSearchModalVisible, setIsSearchModalVisible] = useState(false);
  const [modalSearchValue, setModalSearchValue] = useState('');
  
  const [menuOpen, setMenuOpen] = useState(false);
  const inputRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleModalSearch = () => {
    if (modalSearchValue.trim()) {
      navigate(`/Product/search/${encodeURIComponent(modalSearchValue.trim())}`);
      setIsSearchModalVisible(false);
      setModalSearchValue('');
    }
  };

  useEffect(() => {
    if (isSearchModalVisible && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 100);
    }
  }, [isSearchModalVisible]);

  const handleMenuAction = () => {
    setMenuOpen(false);
  }

  return (
    <>
      {/* 顶部信息栏 + 图片 */}
      <div className="infoImageContainer">
        <div className="infoBar">
          <div className="infoContent">
            <div className="infoLeft">
              <span>Email: elise@nw-stone.com</span>
              <span>Phone: +86 183 5971 2857</span>
            </div>
            <div className="infoRight">
              <FaFacebookF className="infoIcon" onClick={() => window.open('https://www.facebook.com/nanweistonecrafts/', '_blank')}/>
              <FaInstagram className="infoIcon" onClick={() => window.open('https://www.instagram.com/nanweistone/', '_blank')}/>
              <FaLinkedin className="infoIcon" />
              <FaTiktok className="infoIcon" onClick={() => window.open('https://www.tiktok.com/@nanweistone', '_blank')}/>
            </div>
          </div>
        </div>
        <div className="infoImageWrapper">
          <img src={infoImage} alt="Info Banner" className="infoImage" />
        </div>
      </div>

      {/* 吸顶导航栏 */}
      <div className="headerContainer">
        <div className="headerLeft" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <img
            src={logo}
            alt="logo"
            className="logo"
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          />
          <button
            className="searchBoxButton"
            onClick={() => setIsSearchModalVisible(true)}
          >
            🔍 Search Products
          </button>
        </div>

        {/* 小屏幕菜单按钮 */}
        <div className="mobileMenuIcon" onClick={() => setMenuOpen(!menuOpen)}>
          <MenuOutlined style={{ fontSize: '24px' }} />
        </div>

        {/* PC 导航菜单 */}
        <div className="rightBottom desktopMenu">
          <button className="headerButton" onClick={() => navigate('/')}>HOME</button>
          <button className="headerButton" onClick={() => navigate('/AboutUs')}>ABOUT US</button>
          <button className="headerButton" onClick={() => navigate('/Product')}>PRODUCTS</button>
          <button className="headerButton" onClick={() => navigate('/Blog')}>BLOG</button>
          <button className="headerButton" onClick={() => navigate('/GetInTouch')}>CONTACT US</button>
        </div>

        {/* 移动端菜单 */}
        {menuOpen && (
          <div className="mobileMenu" onClick={handleMenuAction} ref={menuRef}>
            <button className="headerButton" onClick={() => navigate('/')}>HOME</button>
            <button className="headerButton" onClick={() => navigate('/AboutUs')}>ABOUT US</button>
            <button className="headerButton" onClick={() => navigate('/Product')}>PRODUCTS</button>
            <button className="headerButton" onClick={() => navigate('/Blog')}>BLOG</button>
            <button className="headerButton" onClick={() => navigate('/GetInTouch')}>CONTACT US</button>
          </div>
        )}
      </div>

      {/* 搜索弹窗 */}
      <Modal
        open={isSearchModalVisible}
        onCancel={() => setIsSearchModalVisible(false)}
        footer={null}
        closable={false}
        centered={false}
        className="fullWidthSearchModal"
        width="100%"
        style={{ top: '30%' }}
      >
        <div className="fullWidthModalContent">
          <h2 className="searchTitle">WHAT ARE YOU LOOKING FOR?</h2>
          <Input
            ref={inputRef}
            size="large"
            placeholder="Search..."
            value={modalSearchValue}
            onChange={(e) => setModalSearchValue(e.target.value)}
            onPressEnter={handleModalSearch}
            suffix={
              <Button
                type="text"
                icon={<SearchOutlined />}
                onClick={handleModalSearch}
              />
            }
            className="fullWidthSearchInput"
          />
        </div>
      </Modal>
    </>
  );
};

export default Header;